// @ts-strict-ignore
import { Component, OnInit } from '@angular/core';
import { UserComponentPresenter } from '@user/components/user-component.presenter';
import { UserModel } from '@user/model/user.model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ExportType } from '../export-print/export-print-file.component';
import { ProjectComponentPresenter } from '../../project-component.presenter';
import { UserPermissionService } from '@user/service/user-permission.service';

@Component({
  standalone: false,
  templateUrl: './choice-action-export-print.component.html',
  selector: 'app-choice-action-export-print',
})
export class ChoiceActionExportPrintComponent implements OnInit {

  public readonly types: ExportType[] = [ExportType.WSIX, ExportType.WSCX];

  public actionType: ExportType;

  public wsixAvailable: boolean;
  public wscxAvailable: boolean;

  constructor(
    private bsModalRef: BsModalRef,
    private projectComponentPresenter: ProjectComponentPresenter,
    private userPermissionService: UserPermissionService,
    private userModel: UserModel,
    private userComponentPresenter: UserComponentPresenter,
  ) {
  }

  public ngOnInit(): void {
    this.wsixAvailable = this.userPermissionService.isExportToWSIXVisible();
    this.wscxAvailable = this.userPermissionService.isExportToWSCXVisible();
    this.actionType = this.wsixAvailable ? this.types[0] : this.types[1];
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public async onConfirm(): Promise<void> {
    if (this.userModel.isGuestUser()) {
      await this.userComponentPresenter.presentReloginComponent(true, false, true);
      if (this.userModel.isGuestUser()) {
        this.close();
        return;
      }
    }
    this.projectComponentPresenter.openExportPrintFilePopup(this.actionType);
    this.close();
  }
}
